/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAttachFileRtl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 22a7 7 0 0 1-7-7V7a5 5 0 0 1 10 0v8a3 3 0 1 1-6 0V9h2v6a1 1 0 1 0 2 0V7a3 3 0 1 0-6 0v8a5 5 0 0 0 10 0V5h2v10a7 7 0 0 1-7 7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAttachFileRtl as AttachFileRtl };
